import { create } from 'zustand';
import { IExportState, StateType } from '@/version-types';
import { getState, useState } from '../index';

/** 存储类型 */
interface IStore {
    id: string;
    version: number;
    destroy: () => void;
    incr: () => void;
}

/** 创建存储 */
const createState = (identity: string) => {
    return create<IStore>((set, get) => ({
        destroy() {
            set({ version: get().version + 1 });
        },
        incr() {
            set({ version: get().version + 1 });
        },
        id: identity,
        version: 0,
    }));
};

/** 存储名称 */
const name = 'editor-identity-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取 id */
export const useIdentityState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getIdentityState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

/** 导出存储 */
export default {
    name,
    createState,
} as IExportState;
